import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  duesGroups: [],
  is_posted: false,
}
const DefDuesGroupSlice = createSlice({
  name: 'duesGroupSlice',
  initialState: initialState,
  reducers: {
    handlePost:(state,action)=>{
      state.is_posted = action.payload
    },
    showDuesGroup: (state, action) => {
      state.duesGroups = action.payload
    },
    addDuesGroup: (state, action) => {
      state.duesGroups.push(action.payload)
    },
    updateDuesGroup: (state, action) => {
      const updateIndex = state.duesGroups.findIndex(
        (el) => el.id === action.payload.id
      )
      state.duesGroups[updateIndex] = action.payload
    },
    deleteDuesGroup: (state, action) => {
      state.duesGroups = state.duesGroups.filter(
        (el) => el.id !== action.payload
      )
    },
  },
})
export const {
  handlePost,
  showDuesGroup,
  addDuesGroup,
  updateDuesGroup,
  deleteDuesGroup,
} = DefDuesGroupSlice.actions
export default DefDuesGroupSlice.reducer
